module.exports = __webpack_public_path__ + "img/product_info.085c51cb.svg";